import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const decorationTagManager = createBooleanTagManager({
  jsonQueryKey: 'has_decoration',
  trueLabel: 'С отделкой',
  falseLabel: 'Без отделки',
  id: 'decorationTag',
});
